import moment from 'moment'
import React, { Component, Fragment } from 'react'
import ReactLoading from 'react-loading'

import { myFirestore, myStorage } from '../../Config/firebase';
import images from '../Themes/Images'
import './ChatBoard.css'
import './custom.css'
import { AppString } from '../Const'
import { fetchDataToggle } from '../../../../firebaseHelper';
import { ModalIndex } from '../Modal/modal';
import { Col, Row } from 'react-bootstrap';
import { v1 as uuidv1 } from 'uuid';
export default class ChatBoardDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isShowSticker: false,
      inputValue: "",
      showModal: false,
      currentImg : ""
    };
    this.currentUserId = localStorage.getItem(AppString.ID);
    this.currentUserAvatar = localStorage.getItem(
      AppString.PHOTO_URL
    );
    this.currentUserNickname = localStorage.getItem(
      AppString.NICKNAME
    );
    this.listMessage = [];
    this.currentPeerUser = this.props.currentPeerUser;
    this.currentUserFirebase = this.props.currentUserFirebase;
    this.groupChatId = null;
    this.removeListener = null;
    this.currentPhotoFile = null;
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  componentDidMount() {
    // For first render, it's not go through componentWillReceiveProps
    this.getListHistory();
  }

  componentWillUnmount() {
    if (this.removeListener) {
      this.removeListener();
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.currentPeerUser) {
      this.currentPeerUser = newProps.currentPeerUser;
      this.getListHistory();
    }
  }

  getListHistory = () => {
    try {
      if (this.removeListener) {
        this.removeListener();
      }
      this.listMessage.length = 0;
      this.setState({ isLoading: true });
      if (!!this.currentUserId && !!this.currentPeerUser) {
        this.groupChatId = `${this.currentUserId}-${this.currentPeerUser?.userId}-${this.currentPeerUser?.id}`;
        // Get history and listen new data added
        this.removeListener = myFirestore
          .collection(AppString.NODE_MESSAGES)
          .doc(this.groupChatId)
          .collection(this.groupChatId)
          .onSnapshot(
            (snapshot) => {
              snapshot.docChanges().forEach((change) => {
                if (change.type === AppString.DOC_ADDED) {
                  this.listMessage.push(change.doc.data());
                }
              });
              this.setState({ isLoading: false });
            },
            (err) => {
              console.log(err.toString());
            }
          );

      }
    }
    catch (err) {
      console.log('err', err);
    }
  };

  openListSticker = () => {
    this.setState({ isShowSticker: !this.state.isShowSticker });
  };

  onSendMessage = (content, type) => {
    if (this.state.isShowSticker && type === 2) {
      this.setState({ isShowSticker: false });
    }

    if (content.trim() === "") {
      return;
    }

    const timestamp = moment()
      .valueOf()
      .toString();

    const itemMessage = {
      idFrom: this.currentUserId,
      idTo: this.currentPeerUser?.id,
      timestamp: timestamp,
      content: content.trim(),
      type: type,
    };

    myFirestore
      .collection(AppString.NODE_MESSAGES)
      .doc(this.groupChatId)
      .collection(this.groupChatId)
      .doc(timestamp)
      .set(itemMessage)
      .then(async () => {
        this.setState({ inputValue: "" });

        //send notification
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append(
          "Authorization",
          `key=${process.env.REACT_APP_SERVER_KEY}`
        );
        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({
            to: this.currentUserFirebase?.pushToken,
            notification: {
              body: type === 1 ? "Image" : content,
              title: `Message from ${this.currentPeerUser?.nickname} (Load#: ${this.currentPeerUser?.id})`,
              sound: "default"
            },
            apns: {
              headers: {
                'apns-priority': '10',
              },
              payload: {
                aps: {
                  sound: 'default',
                }
              },
            },
            android: {
              priority: 'high',
              notification: {
                sound: 'default',
              }
            },
            data: {
              peerUser1: this.currentUserFirebase,
              peerUser2: this.currentPeerUser,
            },
          }),
          redirect: "follow",
        };


        fetch("https://fcm.googleapis.com/fcm/send", requestOptions)
          .then((response) => response.text())
          .then(async (response) => {
            const res = await response;
            if (res.status === 200) {
              console.log("res.body");
            }
            return false;
          })
          .then((res) => {
            if (res?.Code === "400") {
              return false;
            }
            console.log('ewee',this.currentPeerUser)
            //Save Notification list
            fetchDataToggle(`${this.currentUserFirebase.id}-${this.currentPeerUser?.id}-${uuidv1().toString()}`, {
              header: `Message from ${this.currentPeerUser?.nickname} (Load#: ${this.currentPeerUser?.id})`,
              message: type === 1 ? "Image" : content,
              loadCode: this.currentPeerUser?.id,
              idFrom: this.currentUserId,
              idTo: this.currentPeerUser?.userId,
              date: moment(new Date()).format("MM-DD-YYYY hh:mm a"),
              timestamp: moment()
                .valueOf()
                .toString(),
              peerNickname: this.currentPeerUser?.nickname,
              shipperToken : this.currentPeerUser?.shipperToken,
              photoUrl : this.currentPeerUser?.photoUrl,
            });

            //Save Last Message
            try {
              myFirestore
                .collection(AppString.NODE_LOADS)
                .doc(`${this.currentPeerUser?.id}-${this.currentPeerUser?.userId}-${this.currentUserId}`)
                .update({
                  date: moment(new Date()).format("MM-DD-YYYY hh:mm a"),
                  timestamp: moment()
                    .valueOf()
                    .toString(),
                  lastMessage: content,
                  isReadMobile: false,
                })
                .then((data) => {
                  console.log(data);
                });
            } catch (err) {
              console.error("err", err);
            }
          });
      })
      .catch((err) => {
        console.log(err.toString());
      });
  };

  onChoosePhoto = (event) => {
    try{
      if (event.target.files && event.target.files[0]) {
        this.setState({ isLoading: true });
        this.currentPhotoFile = event.target.files[0];
        // Check this file is an image?
        const prefixFiletype = event.target.files[0].type.toString();
        if (prefixFiletype.indexOf(AppString.PREFIX_IMAGE) === 0) {
          this.uploadPhoto();
        } else {
          this.setState({ isLoading: false });
          console.log("This file is not an image");
        }
      } else {
        this.setState({ isLoading: false });
      }
    }catch(err) {
      console.log('err',err);
    }
  };

  uploadPhoto = () => {
    if (this.currentPhotoFile) {
      const timestamp = moment()
        .valueOf()
        .toString();

      const uploadTask = myStorage
        .ref()
        .child(timestamp)
        .put(this.currentPhotoFile);

      uploadTask.on(
        AppString.UPLOAD_CHANGED,
        null,
        (err) => {
          this.setState({ isLoading: false });
          console.log(err.message);
        },
        () => {
          uploadTask.snapshot.ref
            .getDownloadURL()
            .then((downloadURL) => {
              this.setState({ isLoading: false });
              this.onSendMessage(downloadURL, 1);
            });
        }
      );
    } else {
      this.setState({ isLoading: false });
      console.log("File is null");
    }
  };

  onKeyboardPress = (event) => {
    if (event.key === "Enter") {
      this.onSendMessage(this.state.inputValue, 0);
    }
  };

  scrollToBottom = () => {
    if (this.messagesEnd) {
      this.messagesEnd.scrollIntoView({});
    }
  };

  render() {
    return (
      <Fragment>
        <div className='scroll-y mr-n5 pr-5 h-450px'>
          {this.renderListMessage()}
          <div
            style={{ float: "left", clear: "both" }}
            ref={(el) => {
              this.messagesEnd = el;
            }}
          />
        </div>
        {/* Modal Assign Load */}
        <ModalIndex
          show={this.state.showModal}
          onHide={() => this.setState({ showModal: false })}
          size="md"
          title={`Show Image`}
          content={
            <Fragment>
              <Row>
                <Col>
                  <img
                    className="imgItemRight"
                    style={{ width: '100%', height: 'auto' }}
                    src={this.state.currentImg}
                    alt="content message"
                  />
                </Col>
              </Row>
            </Fragment>
          }
          footerContent={
            <Fragment>
              {" "}
              <button
                onClick={() => this.setState({ showModal: false })}
                className="mr-3 btn btn-light btn-elevate"
              >
                Close
              </button>
            </Fragment>
          }
        />

        {/* Stickers */}
        {/* {this.state.isShowSticker ? this.renderStickers() : null} */}

        {/* View bottom */}
        <div className="card-footer py-0" style={{ padding: 'inherit' }}>

          <div className='d-flex flex-stack justify-contenr-between'>
            <div className='d-flex align-items-center mr-2'>
              <img
                className="icOpenGallery"
                src={images.ic_photo}
                alt="icon open gallery"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  try {
                    this.refInput.click();
                  } catch (err) {
                    console.log(err);
                  }
                }}
              />
              <input
                ref={(el) => {
                  this.refInput = el;
                }}
                accept="image/*"
                className="viewInputGallery"
                type="file"
                onChange={this.onChoosePhoto}
              />
            </div>
            <div className='flex-grow-1'>
              <textarea className='form-control form-control-flush mb-3 border-0 pt-10' rows={0} placeholder="Type a message..." value={this.state.inputValue}
                onChange={(event) => {
                  this.setState({ inputValue: event.target.value });
                }}
                onKeyPress={this.onKeyboardPress} style={{ resize: "none" }} />
            </div>
            <img
              className="icSend"
              src={images.ic_send}
              alt="icon send"
              onClick={() =>
                this.onSendMessage(this.state.inputValue, 0)
              }
            />
          </div>
        </div>

        {/* Loading */}
        {this.state.isLoading ? (
          <div className="viewLoading">
            <ReactLoading
              type={"spin"}
              color={"#203152"}
              height={"3%"}
              width={"3%"}
            />
          </div>
        ) : null}

      </Fragment>
    );
  }

  renderListMessage = () => {
    if (this.listMessage.length > 0) {
      let viewListMessage = [];
      this.listMessage.forEach((item, index) => {
        if (item.idFrom === this.currentUserId) {
          // Item right (my message)
          if (item.type === 0) {
            viewListMessage.push(
              <div className='d-flex justify-content-end mb-5' key={item.timestamp}>
                <div className='d-flex flex-column align-items-end'>
                  <div className='p-5 rounded bg-light-success text-dark font-weight-bold mw-lg-400px text-right'>
                    {item.content}
                  </div>
                  {this.isLastMessageRight(index) ? (
                    <span className="textTimeRight">
                      {moment(Number(item.timestamp)).format(
                        "lll"
                      )}
                    </span>
                  ) : null}
                </div>
              </div>
            );
          } else if (item.type === 1) {
            viewListMessage.push(
              <div className='d-flex justify-content-end mb-5' key={item.timestamp}>
                <div className='d-flex flex-column align-items-end'>
                  <div className='p-1 rounded text-dark font-weight-bold mw-lg-400px text-right' style={{ cursor: 'pointer' }} onClick={() => {
                    this.setState({
                      showModal: true,
                      currentImg: item.content
                    });
                  }}>
                    <img
                      className="imgItemRight"
                      src={item.content}
                      alt="content message"
                    />
                  </div>
                  {this.isLastMessageRight(index) ? (
                    <span className="textTimeRight">
                      {moment(Number(item.timestamp)).format(
                        "lll"
                      )}
                    </span>
                  ) : null}
                </div>
              </div>
            );
          } else {
            viewListMessage.push(
              <div className='d-flex justify-content-end mb-5' key={item.timestamp}>
                <div className='d-flex flex-column align-items-end'>
                  <div className='p-5 rounded text-dark font-weight-bold mw-lg-400px text-right'>
                    <img
                      className="imgItemRight"
                      src={this.getGifImage(item.content)}
                      alt="content message"
                    />
                  </div>
                  {this.isLastMessageRight(index) ? (
                    <span className="textTimeRight">
                      {moment(Number(item.timestamp)).format(
                        "lll"
                      )}
                    </span>
                  ) : null}
                </div>
              </div>
            );
          }
        } else {
          // Item left (peer message)
          if (item.type === 0) {
            viewListMessage.push(
              <div className='d-flex justify-content-left mb-5' key={item.timestamp}>
                <div className='d-flex flex-column align-items-left'>
                  <div className='p-5 rounded bg-light-info text-dark font-weight-bold mw-lg-400px text-left'>
                    {item.content}
                  </div>
                  {this.isLastMessageLeft(index) ? (
                    <span className="textTimeLeft">
                      {moment(Number(item.timestamp)).format(
                        "lll"
                      )}
                    </span>
                  ) : null}
                </div>
              </div>
            );
          } else if (item.type === 1) {
            viewListMessage.push(
              <div className='d-flex justify-content-left mb-5' key={item.timestamp}>
                <div className='d-flex flex-column align-items-left'>
                  <div className='p-1 rounded text-dark font-weight-bold mw-lg-400px text-left' style={{ cursor: 'pointer' }} onClick={() => {
                    this.setState({
                      showModal: true,
                      currentImg: item.content
                    });
                  }}>
                    <img
                      className="imgItemLeft"
                      src={item.content}
                      alt="content message"
                    />
                  </div>
                  {this.isLastMessageLeft(index) ? (
                    <span className="textTimeLeft">
                      {moment(Number(item.timestamp)).format(
                        "lll"
                      )}
                    </span>
                  ) : null}
                </div>
              </div>
            );
          } else {
            viewListMessage.push(
              <div className='d-flex justify-content-left mb-5' key={item.timestamp}>
                <div className='d-flex flex-column align-items-left'>
                  <div className='p-5 rounded  text-dark font-weight-bold mw-lg-400px text-left'>
                    <img
                      className="imgItemLeft"
                      src={this.getGifImage(item.content)}
                      alt="content message"
                    />
                  </div>
                  {this.isLastMessageLeft(index) ? (
                    <span className="textTimeLeft">
                      {moment(Number(item.timestamp)).format(
                        "lll"
                      )}
                    </span>
                  ) : null}
                </div>
              </div>
            );
          }
        }
      });
      return viewListMessage;
    } else {
      return (
        <div className="viewWrapSayHi">
          <span className="textSayHi text-muted">
            No Messages found
          </span>
        </div>
      );
    }
  };

  renderStickers = () => {
    return (
      <div className="viewStickers">
        <img
          className="imgSticker"
          src={images.mimi1}
          alt="sticker"
          onClick={() => this.onSendMessage("mimi1", 2)}
        />
        <img
          className="imgSticker"
          src={images.mimi2}
          alt="sticker"
          onClick={() => this.onSendMessage("mimi2", 2)}
        />
        <img
          className="imgSticker"
          src={images.mimi3}
          alt="sticker"
          onClick={() => this.onSendMessage("mimi3", 2)}
        />
        <img
          className="imgSticker"
          src={images.mimi4}
          alt="sticker"
          onClick={() => this.onSendMessage("mimi4", 2)}
        />
        <img
          className="imgSticker"
          src={images.mimi5}
          alt="sticker"
          onClick={() => this.onSendMessage("mimi5", 2)}
        />
        <img
          className="imgSticker"
          src={images.mimi6}
          alt="sticker"
          onClick={() => this.onSendMessage("mimi6", 2)}
        />
        <img
          className="imgSticker"
          src={images.mimi7}
          alt="sticker"
          onClick={() => this.onSendMessage("mimi7", 2)}
        />
        <img
          className="imgSticker"
          src={images.mimi8}
          alt="sticker"
          onClick={() => this.onSendMessage("mimi8", 2)}
        />
        <img
          className="imgSticker"
          src={images.mimi9}
          alt="sticker"
          onClick={() => this.onSendMessage("mimi9", 2)}
        />
      </div>
    );
  };

  hashString = (str) => {
    let hash = 0;
    for (let i = 0; i < str?.length; i++) {
      hash += Math.pow(str.charCodeAt(i) * 31, str.length - i);
      hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
  };

  getGifImage = (value) => {
    switch (value) {
      case "mimi1":
        return images.mimi1;
      case "mimi2":
        return images.mimi2;
      case "mimi3":
        return images.mimi3;
      case "mimi4":
        return images.mimi4;
      case "mimi5":
        return images.mimi5;
      case "mimi6":
        return images.mimi6;
      case "mimi7":
        return images.mimi7;
      case "mimi8":
        return images.mimi8;
      case "mimi9":
        return images.mimi9;
      default:
        return null;
    }
  };

  isLastMessageLeft(index) {
    if (
      (index + 1 < this.listMessage.length &&
        this.listMessage[index + 1].idFrom ===
        this.currentUserId) ||
      index === this.listMessage.length - 1
    ) {
      return true;
    } else {
      return false;
    }
  }

  isLastMessageRight(index) {
    if (
      (index + 1 < this.listMessage.length &&
        this.listMessage[index + 1].idFrom !==
        this.currentUserId) ||
      index === this.listMessage.length - 1
    ) {
      return true;
    } else {
      return false;
    }
  }
}
